import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { en } from "@/lang/en";
import { ja } from "@/lang/ja";

/**
 * i18n の初期化。
 *
 * 名前空間は 5 つと少なく全体でも数 KB なので、動的 import ではなく静的に
 * 束ねている（キー集合のパリティを src/lang/parity.test.ts で静的に検証できる）。
 */
export const SUPPORTED_LANGUAGES = ["ja", "en"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const LANGUAGE_STORAGE_KEY = "zeus-bpm-lang";

export function initI18n(lng?: SupportedLanguage) {
  if (i18next.isInitialized) return i18next;

  const instance = i18next.use(initReactI18next);
  // lng を明示した場合（テスト等）は検出を挟まない
  if (lng === undefined) instance.use(LanguageDetector);

  instance.init({
    resources: { ja: { ...ja }, en: { ...en } },
    lng,
    // 主言語は ja。en は同じキー集合を維持する前提のフォールバック先
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES,
    defaultNS: "common",
    ns: Object.keys(ja),
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ["localStorage"],
    },
  });

  return i18next;
}
